export default __webpack_public_path__ + "static/media/failed_note.de9c6ba0.svg";